import React, { useState, useEffect } from "react";
import "./styles.scss";
import { Container, Row, Col } from "react-bootstrap";
import moment from "moment";
import { ConfigProvider, Select } from "antd";
import "moment/locale/zh-cn";
import locale from "antd/lib/locale/ja_JP";
import "antd/dist/antd.css";
import { useSelector } from "react-redux";
import stringJp from "../../constants/stringJP";

function Birthday(props) {
    const { birthday, setBirthday, isCheck, index_card } = props;
    const databirth = useSelector((state) => state.chart.dataChart.user);

    const [valueDate, setValueDate] = useState({ year: "1990", month: "01", day: "01" });

    const [count, setCount] = useState(0);

    const handleCheckDisable = () => {
        if (index_card === "0" && databirth?.birthday_changeable !== 1) {
            return true;
        } else {
            return false;
        }
    };
    console.log(111111, valueDate);

    useEffect(() => {

        if(birthday){
            console.log(123, birthday?.toString().slice(5, 7))
            setValueDate({ year: birthday?.toString().slice(0, 4), month: birthday.toString().slice(5, 7), day: birthday.toString().slice(8, 10) })
        }
        
    }, [isCheck]) // eslint-disable-line react-hooks/exhaustive-deps

    const d = new Date(),
        year = d.getFullYear();
    const dataDummy = Array.from(Array(year + 1).keys())
    const listYear = dataDummy.map(item => {
        if (item < 10) {
            return `000${item}`
        } else if (item < 100) {
            return `00${item}`
        } else if (item < 1000) {
            return `0${item}`
        } else {
            return item
        };
    });
    listYear.shift();
    if (birthday > moment().endOf("day")) {
        setBirthday(new Date());
    }

    const { Option } = Select;

    const dataMonth = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

    const daysInMonth = new Date(valueDate.year, valueDate.month, 0).getDate();
    const dateMonth = daysInMonth && Array.from(Array(daysInMonth + 1).keys());
    dateMonth && dateMonth?.shift();

    const dateOfMonth = dateMonth && dateMonth?.map(item => {
        if (item < 10) {
            return `0${item}`
        } else {
            return item
        };
    });

    useEffect(() => {
        if (daysInMonth < valueDate.day) {
            setValueDate({ ...valueDate, day: daysInMonth })
            setBirthday(valueDate.year + "/" + valueDate.month + "/" + daysInMonth)
        };

        const convertDate = new Date(valueDate.year, valueDate.month, valueDate.day);
        if (moment(convertDate).format('YYYY/MM/DD') > moment(new Date()).format('YYYY/MM/DD')) {
            setValueDate({ year: moment(new Date()).format('YYYY'), month: moment(new Date()).format('MM'), day: moment(new Date()).format('DD') })
            setBirthday(moment(new Date()).format('YYYY/MM/DD'));
        };
    }, [count]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <ConfigProvider locale={locale}>
                <Container className="birth">
                    <Row className="row">
                        <meta name="viewport" content="initial-scale=1, maximum-scale=1" />
                        <Col xs={4} className="year">
                            <Select
                                size={'default'}
                                // value={moment(birthday).format('YYYY')}
                                value={valueDate.year}
                                onChange={(newValue) => {
                                    setValueDate({ ...valueDate, year: newValue });
                                    setCount(count + 1);
                                    setBirthday(newValue + "/" + valueDate.month + "/" + valueDate.day);
                                }}
                                disabled={handleCheckDisable()}
                            >
                                {listYear.map(item => <Option key={item}>{item}</Option>)}
                                {/* {childrenYear} */}
                            </Select>
                            <div className="birth-date">
                                {stringJp.label_birthday_info_year}
                            </div>
                        </Col>
                        <Col xs={4} className="month">
                            <Select
                                size={'default'}
                                // value={moment(birthday).format('MM')}
                                value={valueDate.month}
                                onChange={(newValue) => {
                                    setValueDate({ ...valueDate, month: newValue });
                                    setBirthday(valueDate.year + "/" + newValue + "/" + valueDate.day);
                                    setCount(count + 1);
                                }}
                                disabled={handleCheckDisable()}
                            >
                                {dataMonth.map(item => <Option key={item}>{item}</Option>)}
                                {/* {childrenMonth} */}
                            </Select>
                            <div className="birth-date">
                                {stringJp.label_birthday_info_month}
                            </div>
                        </Col>
                        <Col xs={4} className="date">
                            <Select
                                size={'default'}
                                // value={moment(birthday).format('DD')}
                                value={valueDate.day}
                                onChange={(newValue) => {
                                    setValueDate({ ...valueDate, day: newValue });
                                    setCount(count + 1);
                                    setBirthday(valueDate.year + "/" + valueDate.month + "/" + newValue);
                                }}
                                disabled={handleCheckDisable()}
                            >
                                {dateOfMonth && dateOfMonth.map(item => <Option key={item}>{item}</Option>)}
                                {/* {childrenDay} */}
                            </Select>
                            <div className="birth-date">
                                {stringJp.label_birthday_info_day}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </ConfigProvider>
        </div>
    );
}
export default Birthday;
